module.exports = __webpack_public_path__ + "img/gifts.26b144d9.png";